var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 23.75C18.993 23.75 23.75 18.993 23.75 13.125C23.75 7.257 18.993 2.5 13.125 2.5C7.257 2.5 2.5 7.257 2.5 13.125C2.5 18.993 7.257 23.75 13.125 23.75Z",
    stroke: "#437D76",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6604 8.96444C15.7556 8.05962 14.5056 7.5 13.1249 7.5C11.7442 7.5 10.4942 8.05962 9.58936 8.96444",
    stroke: "#437D76",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7637 20.7635L26.067 26.0669",
    stroke: "#437D76",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.b9ec5b352dae37eb1719356cb1f35026.svg";
export { ForwardRef as ReactComponent };